import { primarySurvey } from '../project-workspace/workspaceQuote.helpers';

export type SurveyBinding = {
  kind: string;
  optionId?: string | null;
  documentVersionId?: string | null;
};

export type WorkspacePricingChoice =
  | { mode: 'legacy' }
  | { mode: 'survey'; survey: 'first' | 'final'; versionId: string | null };

type Sheet = {
  kind: 'first' | 'final';
  optionId: string | null;
  documentVersionId: string | null;
};

/**
 * Workspace quotes are priced from the Final Survey when that sheet exists,
 * otherwise from the First Survey. Interim document versions are ignored.
 * A quote with no First or Final sheet bound to it stays on the legacy version list.
 */
export function chooseWorkspacePricing(
  surveys: SurveyBinding[],
  documentVersionIds: string[],
): WorkspacePricingChoice {
  const owned = new Set(documentVersionIds.map((id) => String(id || '').trim()).filter(Boolean));
  const sheets = surveys.filter((survey) => survey.kind === 'first' || survey.kind === 'final');
  const boundHere = sheets.filter((survey) => owned.has(String(survey.documentVersionId || '').trim()));
  if (boundHere.length === 0) return { mode: 'legacy' };

  const unbound = sheets.filter((survey) => !String(survey.documentVersionId || '').trim());
  const pool: Sheet[] = [...boundHere, ...unbound].map((survey) => ({
    kind: survey.kind as 'first' | 'final',
    optionId: survey.optionId ?? null,
    documentVersionId: String(survey.documentVersionId || '').trim() || null,
  }));

  const final = primarySurvey(pool, 'final');
  if (final) return { mode: 'survey', survey: 'final', versionId: ownedVersion(final, owned) };
  const first = primarySurvey(pool, 'first');
  if (first) return { mode: 'survey', survey: 'first', versionId: ownedVersion(first, owned) };
  return { mode: 'legacy' };
}

function ownedVersion(sheet: Sheet, owned: Set<string>): string | null {
  return sheet.documentVersionId && owned.has(sheet.documentVersionId) ? sheet.documentVersionId : null;
}
